import _ from 'lodash';

import {
  flexValueToCss, numberToPx, paddingToCss, capPaddingSides,
  resolveFlexEnabled,
} from '../../flex/flexCss';

const storedFlexProperty = flexProperty => _.omitBy(flexProperty, _.isNil);

export const DEFAULT_FLEX_PROPERTY = {
  justifyContent: 'flexStart',
  alignItems: 'flexStart',
  alignContent: 'flexStart',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '0px',
  padding: { topLeft: '0px', topRight: '0px', bottomLeft: '0px', bottomRight: '0px', lock: true },
};

export function flexPropertyToCss(flexProperty) {
  const fp = _.defaults({}, flexProperty, DEFAULT_FLEX_PROPERTY);
  const gap = numberToPx(fp.gap);
  return {
    display: 'flex',
    flexDirection: flexValueToCss(fp.flexDirection),
    justifyContent: flexValueToCss(fp.justifyContent),
    alignItems: flexValueToCss(fp.alignItems),
    alignContent: flexValueToCss(fp.alignContent),
    flexWrap: flexValueToCss(fp.flexWrap),
    columnGap: gap,
    rowGap: gap,
    padding: paddingToCss(fp.padding),
    boxSizing: 'border-box',
  };
}

export function getCardFlexConfig(cardProps, breakpoint, parentFlex = false) {
  const desktop = _.get(cardProps, 'properties.desktop') || {};
  const isFlexLayout = resolveFlexEnabled(cardProps, breakpoint, parentFlex);

  if (breakpoint !== 'mobile') {
    return {
      isFlexLayout,
      flexProperty: _.defaults({}, storedFlexProperty(desktop.flexProperty), DEFAULT_FLEX_PROPERTY),
    };
  }

  const mobile = _.get(cardProps, 'properties.mobile') || {};

  const flexProperty = _.defaults({}, storedFlexProperty(mobile.flexProperty), storedFlexProperty(desktop.flexProperty), DEFAULT_FLEX_PROPERTY);
  if (_.get(mobile, 'flexProperty.padding') == null) {
    flexProperty.padding = capPaddingSides(flexProperty.padding);
  }

  return {
    isFlexLayout,
    flexProperty,
  };
}

